enum LinkAttributionTypes {
    branding_attribution_social_link = 'branding_attribution_social_link',
}
enum SocialLinkTypes {
    web = 'web',
    instagram = 'instagram',
}
interface SocialLink {
    url: string;
    _type: LinkAttributionTypes;
    type: SocialLinkTypes;
}

export interface BrandState {
    /*
     * Image to be displayed in the metro's header
     */
    headerImageUrl: string;
    /*
     * Image to be displayed in the metro's header on small viewports
     */
    headerSmallImageUrl: string;
    /*
     * Image to be displayed in the middle section of the page for selected metros
     */
    middleImageUrl: string;
    /*
     * Small Image to be displayed in the middle section of the page on small viewports
     */
    middleSmallImageUrl: string;
    /*
     * Image to be displayed in the footer section of the page for selected metros
     */
    footerImageUrl: string;
    /*
     * Image to be displayed in the footer section of the page on small viewports
     */
    footerSmallImageUrl: string;
    /*
     * Artist summary provided for the artist's attribution
     */
    artistSummary: string;
    /*
     * The artist's chosen image to represent themselves
     */
    artistImageUrl: string;
    /*
     * Artist name
     */
    artistName: string;
    /*
     * Decorative image provided by artist
     */
    decorationTopLeftUrl: string;
    /*
     * Decorative image provided by artist
     */
    decorationTopRightUrl: string;
    /*
     * Decorative image provided by artist
     */
    decorationBottomLeftUrl: string;
    /*
     * Decorative image provided by artist
     */
    decorationBottomRightUrl: string;
    /*
     * Artist social links
     */
    artistSocialLinks: SocialLink[];
}
